/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { FormikProps } from 'formik'
import { useRef } from 'react'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Lightbox } from 'nxui/src'

/**********************************************************************************************************
 *   COMPONENT IMPORTS
 **********************************************************************************************************/
import UpdateEPPCodeForm from 'containers/domains/forms/updateEPPCode.form'

/**********************************************************************************************************
 *   TYPES/INTERFACE
 **********************************************************************************************************/
interface Props {
    id: number
    status: boolean
    close: () => void
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function UpdateEPPCodeLightbox({ id, status, close }: Props) {
    const formRef = useRef<FormikProps<{ epp: string }>>(null)

    /*   RENDER COMPONENT
     *****************************************************/
    return (
        <Lightbox
            title={'EPP Code'}
            description={'Updating EPP Code is required only when your domain is being transferred from another registrar and it was incorrect.'}
            content={<UpdateEPPCodeForm id={id} form={formRef} close={close} />}
            conditions={{ state: status, action: () => close() }}
            links={[]}
            actions={[
                {
                    label: 'Back',
                    color: 'secondary',
                    type: 'button',
                    func: () => close()
                },
                {
                    label: 'Update',
                    color: 'primary',
                    type: 'submit',
                    form: 'updateEPPCodeForm'
                }
            ]}
        />
    )
}
/**********************************************************************************************************
 *   COMPONENT END
 **********************************************************************************************************/
